import _zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
	common: {
		loading: '加载中...',
		noMore: '没有更多了',
		documentTitle: "岱恩教育-学员端",
		confirm: '确 认',
		cancel: '取 消',
		cancelApp: '取消预约',
		changetime: '更改时间',
		save: "保 存",
		login: '登 录',
		submit: "提 交",
		nodata: "暂无数据",
		noTime: "暂无可选时间",
		noNotice: "暂无通知",
		noAnnouncement: "暂无公告",
		return: "返 回",
		logout: "退 出",
		giveup: "放 弃",
		iSee: "知道了",
		refreshSuc: "刷新成功",
		clearSuc: "清除成功",
		settingSuc: "设置成功",
		saveSuccess: "保存成功",
		cancelSuc: "取消成功",
		finish: "完 成",
		other: "其他",
		index: "岱恩",
		titleTips: "提 示",
		all: "未 读",
		nothing: "无",
		copySuccess: "复制成功",
		copyFailed: "复制失败",
		daienEducation: "岱恩教育",
		and: "，",
		ended: "。",
		dollar: "元",
		download: "下 载",
		goConfirm: "去确认",
		jxjcancel: "已取消预约，使用的奖学金已返还至账户中",
		userName: '请输入姓名',
		dqwlhmqshzs: "当前网络繁忙，请稍后再试",
		ddqyybfjs: '等当前语音播放结束',
	},
	myJoin: {
		myJoin: '我参与的',
		competitionTime: '活动时间',
		myExam: "考试"
	},
	competition: {
		competitionName: "竞赛名称",
		competitionRank: "竞赛排名",
		competitionDetail: "竞赛详情",
		competitionAward: "竞赛获奖",
		showScore: '晒成绩',
		showOff: "炫耀一下",
		rankLevel: "排名榜",
		myRank: "我的排名",
		yourRank: "你的排名",
		noRank: "暂无排名",
		academicRank: "学霸排行榜",
		pkAcademicRank: "战队排行榜",
		praise: "赞",
		getPraised: "已获得",
		praiseNum: "个赞",
		qrcodeTip1: "来挑战！",
		qrcodeTip2: "长按二维码 关注公众号",
		qrcodeTip3: "扫描二维码分享或者",
		authorities: "颁发机构：",
		issuanceTime: "颁发时间：",
		awardTip1: "恭喜您在",
		pkAwardTip0: "恭喜您的战队",
		pkAwradTip1: "在",
		awardTip2: "中，表现出色！",
		awardTip3: "奖项",
		awardTip4: "奖品",
		awardTip: "特颁发此证，以资鼓励！",
		win: "荣获",
		iam: "我是",
		rank: "排名",
		stuNickName: "学员昵称",
		copyLink: "复制链接",
		rewardReault: "竞赛获奖结果",
		teamRank: "战队排名",
	},
	competitionSeries: {
		subordinate: "所属系列：",
		competitionSeries: "竞赛系列",
		showMore: "展开更多",
		status1: "未开始",
		status2: "进行中",
		status3: "已结束",
		number: "人参加",
	},
	competitionInfo: {
		detail: '竞赛详情',
		title: '竞赛名称：',
		startTime: '竞赛时间：',
		number: '参加人数：',
		people: '个',
		scholarship: '奖学金',
		intro: '竞赛介绍',
		content: '评比内容',
		studyNumber: '自学任务个数',
		lessonNum: '上课次数',
		homeworkNum: '作业任务个数',
		studyALL: '自学总分',
		homeworkScore: '作业总分',
		awardSetting: '奖项设置',
		teamNum: "参赛战队：",
		teamNum2: "参赛战队",
		teamName0: "战队",
		teamName1: "名称",
	},
	login: {
		testingEnvironment: "测试环境",
		switchToFormalEnvironment: "切换为正式环境",
		switchToTestEnvironment: "切换为测试环境",
		pleaseInputEmail: "请输入邮箱",
		pleaseInputRightEmail: "请输入正确的邮箱",
		pleaseInputPassword: "请输入密码",
		mobileLogin: "手机登录",
		forgetPassword: "忘记密码",
		pleaseInputMobile: "请输入手机号",
		pleaseInputRightMobile: "请输入正确的手机号",
		pleaseInputCode: "请输入验证码",
		clickToGet: "点击获取",
		resendCode: "",
		retransmission: "s后重发",
		emailLogin: "邮箱登录",
		codeIsError: "验证码有误",
		codeIsInvalid: "验证码失效",
		selectEmailLogin: "选择邮箱登录",
		emailName: "邮箱名称",
		selectEmail: "请选择邮箱",
		tip1: '请阅读并同意',
		tip2: '《岱恩服务协议》',
		tip3: '及',
		tip4: '《隐私保护政策》',
		tip5: '请阅读并同意《岱恩服务协议》及《隐私保护政策》',
		tip6: '授权以后将会给你推荐更适合你的内容哦。请先用微信进行授权',
		tip7: '请绑定您的手机号',
		tip8: '绑定后可使用手机号登录',
		tg: '跳过'
	},
	resetPassword: {
		identityVerification: "身份验证",
		nextStep: "下一步",
		Confirm: '保存修改',
	},
	courseWares: {
		print: '打 印',
	},
	setPassword: {
		resetPassword: "重置密码",
		inputNewPassword: "输入新密码",
		pleaseConfirmNewPassword: "请确认新密码",
		pleaseInputLetterNumber: "请输入6-20个英文字母、数字、特殊字符",
		twoInputAtypism: "两次输入不一致, 请重新输入",
		passwordEditSuccess: "密码修改成功"
	},
	follow: {
		feedBack: "跟进反馈",
		notCompletedFeedback: "您还未填完反馈",
		followQuestion: "跟进问题",
		confirmCancelFollow: "确定取消填写跟进问题？",
		followSuccess: "提交完成，感谢您的反馈",
		followTips: "跟进提示",
		followListTit: "我的-跟进列表",
		followCon: "请您就本次教务跟进的问题进行确认。",
		follow: '设为关注',
		Unfollow: '取消关注',
		followed: '关注成功',
		isUnfollowed: '是否确认取消关注？',
		Unfollowed: '取消关注成功'
	},
	msg: {
		detail: "详情",
		notice: "通知",
		session: "会话",
		announcement: "公告",
		myMsg: "我的消息",
		msgDetail: "消息详情",
		category1: "上 课",
		category2: "作 业",
		category3: "评 价",
		category4: "考 试",
		category5: "订 课",
		category6: "跟 进",
		category7: "活 动",
		category10: "预 习",
		category8: "其 他",
		noticeIframe: "公告外链",
		year: "年",
		month: "月",
		day: "日",
		hour: "时",
		minute: "分"
	},
	footer: {
		footermenu1: "岱恩",
		footermenu2: "学习中心",
		footermenu3: "我的"
	},
	schedule: {
		ksxq: '课时详情',
		courseSchedule: "课程安排",
		studyPerformance: "学习表现",
		commonProblem: "常见问题",
		guidanceExam: "学前指导",
		placementExam: "入学测试",
		stageExam: "阶段测试",
		finalExam: "结业测试",
		finalEval: "结业评价",
		courseProgress: "课程进度",
		canBook: "可订课次数",
		actually: "实上课次",
		absent: "缺席课次",
		studentAbsentBook: "学生缺席补课",
		teacherAbsentBook: "教师缺席补课",
		notBookTime: "未定时间",
		notStart: "未开始",
		studentAbsent: "学生缺席",
		teacherAbsent: "教师缺席",
		toFinish: "去完成",
		toDynedFinish: "去Dyned完成",
		hasFinished: "已完成",
		inClass: "进行中",
		SignIn: "上课签到",
		ViewCourses: '查看课程',
		Details: "签到详情",
		Absence: "缺席",
		incomplete: "未完成",
		startTask: "开始任务",
		view: "查 看",
		codeInstall: "扫码安装",
		revisable: "可批改",
		corrected: "已批改",
		frequency: "次",
		bookClass: '订 ' + '\xa0\xa0\xa0\xa0' + ' 课',
		leave: '请 假',
		material: '资 料',
		attendClass: '上 课',
		replay: '回 放',
		classAssignment: '上课任务',
		exercise: "自学",
		material1: "资料",
		homework: "作业",
		evalTeacher: "评价教师",
		teacherEval: "教师评价",
		noTime: "暂无",
		reAppointment: "重新预约上课时间",
		classPostponed: "课时顺延",
		noDataWord1: "您在本月的",
		noDataWord2: "天里，还没有开始学习",
		noDataWord3: "加油！乘风破浪会有时，直挂云帆济沧海！",
		sThisMonth: "this month",
		sLastMonth: "last month",
		youIn: "您在",
		of: "的",
		days: "天里...",
		in: "",
		performance: "表现",
		lastMonth: "上月",
		thisMonth: "本月",
		section: "节",
		finishClassHour: "完成课时",
		goToStudy1: "节课，快去学习吧",
		goToStudy2: "分，快去学习吧",
		exceeded: "超过了",
		ofStudent: "的同学",
		exerciseScoreIs: "自学得分为",
		homeworkScoreIs: "作业得分为",
		// exceededClassTips: "超过了 xx% 的同学",
		// encourageClassTips: "已完成 x 节课，快去学习吧",
		exerciseScore: "自学得分",
		// encourageExerciseTips: "自学得分为 xx 分，快去学习吧",
		homeworkScore: "作业得分",
		// encourageHomeworkTips: "作业得分为 xx 分，快去学习吧",
		encourageTips: " 很棒哦！ 继续加油！",
		totalPerformance: "总体表现",
		quarter: "季度",
		classTask: "上课任务",
		homeworkTask: "作业任务",
		exerciseTask: "自学任务",
		exerciseScoreTask: "自学得分",
		homeworkScoreTask: "作业得分",
		finalExamScore: "结业得分",
		score: "(分)",
		individual: "(个)",
		month: "月",
		myPerformance: "我的表现",
		projectNeed: "项目要求",
		myPerformance1: "我的表现 ",
		projectNeed1: " 项目要求",
		projectNotStarted: "项目暂未开始，期待你的表现！",
		noPaper: "没有找到试卷",
		noSurvey: "没有找到问卷",
		pleaseFinishEntranceTestFirst: "请先去完成入学测试",
		noLeave: "不能请假",
		leaveOnlyLatestClass: "只能为最近的一节课请假",
		askForLeaveInAdvance: "小时请假",
		askForLeaveInAdvance1: "小时取消",
		askForCancel: "请提前",
		noCancel: "不能取消",
		noCancel1: "没有找到沙龙课的id, 不能取消",
		noCancel2: "没有找到小班课的id, 不能取消",
		noCancel3: "不能更改时间",
		cancelSalon: "确认取消该沙龙课？",
		cancelSmallClass: "确认取消该小班课？",
		cancelTheme: "确认取消该主题？",
		classTimeChange: "您的上课时间调整为：",
		attendClassOnTime: "请准时上课",
		leaveSuccess: "请假成功",
		classIsOver: "课时已结束",
		toBook: "去选课",
		Preference: '我的偏好',
		continueStudy: "再接再厉 继续学习",
		taskIsFinished: "任务已完成！",
		ikonow: "我知道了",
		neoPlacementTest: "NEO入学测试",
		entranceTestFinished1: "您的入学测试已完成，请等待教务给您安排课程和老师",
		entranceTestFinished2: "您的入学测试已完成，请等待项目开始即可学习和订课",
		qaCategory: '问题分类',
		qaName: '问题名称',
		qaDetail: '详情',
		show: '展开',
		hidden: '收起',
		course: '课程问题',
		booking: '订课问题',
		leaveProblem: '请假问题',
		trainer: '老师问题',
		tech: '技术问题',
		studyApproach: '学习方法',
		others: '其他问题',
		complaints: '投诉建议',
		sales: '销售相关',
		test: '入学测试',
		voice: '语音识别',
		exerciseTimes: "自学学时",
		exerciseTimesIs: "自学学时为",
		goToStudy3: "，快去学习吧",
		minutePoints: "(分钟)",
		studyTime: "学时",
		redo: "重 做",
		redoConfirm: "是否确认重做?",
		placementExamTips: "入学测试提示",
		placementExamFinishTips: "您之前已做过入学测试，已为您获取成绩",
		lessonLabel: "所属标签：",
		teacherName: "教师:",
	},
	study: {
		recommended: '您暂时没有主修课，为您推荐',
		trialClass: '试用课',
		midterm: '中期课程反馈',
		endofterm: '结业课程反馈',
		distanceBegins: "距离开始",
		hour: "时",
		minute: "分",
		second: "秒",
		studycenter: "学习中心",
		salonDetail: "沙龙详情",
		studyTips: "上课提醒",
		joinClass: "进入课堂",
		myLesson: "我的课程",
		major: "主修课",
		salonClass: "沙龙课：",
		reserveSalonLesson: "预约沙龙课",
		canReserveLesson: "可预订",
		reservedLesson: "已预订",
		orderCount: "可订课次数：",
		lessonTeacher: "讲师",
		lessonLimit: "剩余名额",
		lessonDifficulty: "难度",
		lessonProgress: "上课进度",
		lessonTodo: "待完成任务",
		lessonTime: "培训时间",
		lessonLevel0: "零基础",
		lessonLevel1: "初级",
		lessonLevel2: "中级",
		lessonLevel3: "高级",
		lessonLevel4: "不限",
		orderSuccess: "预约成功",
		cancelSuccess: "取消成功",
		cancelOrderLesson: "取消预约",
		startStudy: "开始学习",
		orderLesson: "立即预约",
		order: "预约",
		nearDeadline: "即将到期",
		lessonStoped: "课程暂停",
		topicintro: "主题介绍",
		studySelf: "课前自学",
		studyTask: "上课任务",
		homework: "课后作业",
		evalTeacher: "评价教师",
		teaEvaluation: "教师评价",
		cancelLesson: "取消",
		infoLesson: "资料",
		startLesson: "上课",
		noQuota: "预约名额不足",
		quotaUnit: "人",
		numNoQuota: "不限",
		interactionClassroom: "互动课堂",
		noLimit: "不限",
		weekdate1: "周一",
		weekdate2: "周二",
		weekdate3: "周三",
		weekdate4: "周四",
		weekdate5: "周五",
		weekdate6: "周六",
		weekdate7: "周日",
		yearUnit: "年",
		monthUnit: "月",
		dayUnit: "日",
		today: "今天",
		tomorrow: "明天",
		beforeDawn: "凌晨",
		morning: "上午",
		afternoon: "下午",
		evening: "晚上",
		noData: "暂无",
		classOver: "课时已结束",
		classStarted: "课时已开始",
		cantCancel: "无法取消",
		noLessonData: "暂无课件",
		classsModel: "上课形式",
		classTime: "上课时间",
		taskName: "任务名称",
		countDown: "倒计时",
		status: "状 态",
		operation: "操 作",
		studentMaterial: "学生资料",
		taskBeforeLesson: "课前任务",
		view: "查 看",
		toOrder: "预 约",
		browserNotSupportAudio: "亲 您的浏览器不支持html5的audio标签"
	},
	book: {
		preselectTitle1: '你希望老师的语速？',
		preselectTitle2: '你希望老师纠错的严格度？',
		preselectTitle3: '课程开始时你希望老师破冰聊天吗？',
		preselectTitle4: '你希望如何使用课件授课？',
		noRecorded: '当前课时没有录制',
		selectLessonTip: '您选择的主题在您适配的主题之外，是否继续预定！',
		favoriteTeacher: '选择我的优选老师',
		selectTeacher: '选择老师',
		selectTime: '选择时间',
		NoScore: '暂无评分',
		yxls: '还可以按您的优选老师订课',
		yyxlsdk: '按优选老师订课',
		ymyyxlsdk: '按我的优选老师订课',
		yztds: '按主题订课',
		bookDetail: "订课详情",
		themeDetail: "主题详情",
		selectTheme: "选择主题",
		selectClassName: "预约上课",
		reserveLessonTime: "预约上课时间",
		lessonTheme: "主题",
		lessonThemeTips: "请您对所选主题进行准备，以确保更好的上课效果",
		changeLessonTheme: "更换主题",
		lessonTime: "时间",
		changeLessonTime: "更换时间",
		lessonTeacher: "老师",
		lessonTeacherTips: "系统已为您推荐该时间段最合适老师",
		viewAllEval: "查看教师评价",
		bookSuc: "订课成功",
		resetTheme: "重选主题",
		allTheme: "全部主题",
		bookLessonSelectErr: "该主题需要预习分数达到",
		scoreUnit: "分",
		stillReserve: "仍要预定",
		toPreviewFirst: "先去预习",
		toPreview: "去预习",
		orderLessonTips: "每学满3000分可订一次课哦！",
		orderLessonTips2: "每满1.5小时可以订一次课哦！",
		orderedTips: "该主题您已预约过",
		orderAgain: "还想再次预约吗？",
		bookCourseDialogContent: "课程套餐名称",
		selectTimePlease: "请选择时间",
		yourClass: "您的上课时间由",
		changedLessonTime: "调整为",
		studyOnTimePlease: "请准时上课",
		reserveStudy: "预约上课",
		leaveSuc: "请假成功",
		ChangetimeSuc: "更改时间成功",
		weekLessonStudyTime: "上课时间为每周同一时间，以下是首次上课时间",
		timeImproper: "时间不合适",
		yourSet: "您的",
		orderedCousreSet: "课程套餐上课时间已订好，时间为",
		completedOperation: "您已完成操作",
		pushTimeAsSoonAsPossible: "我们将尽快为您推送合适时间",
		selectReserveLessonTimePlease: "请选择预约上课时间",
		requirementOfClassFrequency: "根据上课频次要求，需要选择",
		needfulTimes: "个时间",
		yourLessonTimeIS: "您的上课时间为",
		pleaseSelectTheme: "请选择主题",
		confirmCancelThisClass: "确定取消本次订课？",
		confirmCancelLeave: "确认取消本次请假？",
		confirmGoback: "确定返回上一步？",
		confirmReserveInfo: "预约信息确认",
		confirmAbandonBookClass: "确定放弃本次订课？",
		timeIsLack: "其他学员也在抢选以下时间，先到先得，尽早确定哦！",
		timeImproperPlease: "时间不合适，请用英文",
		leaveMessages: "给老师留言",
		timeImproperLeave: "时间不合适，给老师留言",
		examConflictTip1: "该时间段与 ",
		examConflictTip2: " 场考试时间有重合，请合理安排考试时间。请问是否继续订课？",
		continueBookClass: "继续订课",
		GMTtips: "(如遇夏令时与显示时间不符，请自行加减时差)",
		noTimeTips: "提示：如无可选时间，请联系教务",
		videoLesson: '支持视频上课',
		audioLesson: '支持音频上课'
	},
	salon: {
		booked: "已预定：",
		bookedUnit: "节",
		spend: "消耗",
		bonuses: "元奖学金",
		bookingOpportunity: "消耗一次订课机会",
		free: "免费",
		cantOrder: "订课次数不足且没有足够的奖学金，无法预约。",
		learnMore: "了解如何获得奖学金",
		confirmGooking: "您可以使用奖学金进行抵扣，是否确定预约？",
		noOrderCantOrder: "本月可订课次不足，无法预约",
		bookLimit: "当日可订课次数已达上限",
		bookSuc: "预约成功，扣除奖学金",
		bookSuc2: "元",
		needToApp: "本节沙龙课课仅限奖学金兑换，请去app上进行预约",
	},
	course: {
		bookCourseDialogTitle: '请预约上课时间',
		unknownTypeCourseware: "未知类型课件",
		coursewareConversionFailed: "课件转换失败",
		viewCourseware: "查看课件"
	},
	eval: {
		evaluate: "评价",
		evalTeacher: "评价教师",
		teaEvaluation: "教师评价",
		overallScore: "综合评价",
		noEval: "暂无评分",
		evalDetail: "评价详情",
		evaldescT: "对老师上课的满意度",
		evaldescW: "对本次批改的满意度",
		gradelevel0: "非常不满意",
		gradelevel1: "不满意",
		gradelevel2: "不太满意",
		gradelevel3: "一般",
		gradelevel4: "满意",
		gradelevel5: "非常满意",
		textareaPlaceholderT: "您对老师教学方式、通话质量、上课效果是否满意？请提出您的宝贵建议吧！（最多200字，此评价内容老师不可见）",
		textareaPlaceholderW: "请提出您的宝贵建议吧！（最多500字，此评价内容老师不可见）",
		badTeacherTips: "您对老师本次上课不满意吗？请您填写具体原因，以便我们后续为您提供更优质的教学服务。",
		likeTeacher: "设为我的最优推荐老师",
		submitSucc: '感谢您的及时反馈，谢谢！',
		noScore: "暂无",
		confirmCancelEval: "确定取消本次评价？",
		noEvalId: "没有找到评价id",
		evalFinished: "已完成评价",
		evalType1: "获得课程证书评价",
		evalType2: "竞赛结束评价",
		evalType3: "竞赛获奖评价",
		evalType4: "完成培训评价",
		evalType5: "课程中期评价",
		evalTips1: "亲爱的学员，恭喜你获得了",
		evalTips2: "证书，在此写下学习感言可立即获得20元奖学金哦！（多多益善，不少于20字哦！）",
		evalTips3: "亲爱的学员，本次竞赛已圆满结束，在此写下比赛心得可立即获得20元奖学金哦！（多多益善，不少于20字哦！）",
		evalTips4: "亲爱的学员，恭喜本次竞赛获奖，在此写下获奖心得可立即获得20元奖学金哦！（多多益善，不少于20字哦！）",
		evalTips5: "亲爱的学员，恭喜你已完成本次项目的培训要求，在此写下学习感言可立即获得20元奖学金哦！（多多益善，不少于20字哦！）",
		evalTips6: "请填写评价内容",
		evalTips7: "评价内容不得少于20字哦！",
		problemType: "问题类型",
		teachingMethod: "教学方法",
		callQuality: "通话质量",
		technical: "技术问题",
		others: "其他",
		problemTypeTips: "请选择问题类型！"

	},
	survey: {
		hint: '温馨提示：带*号为必答题，必答题答完之后才可提交。',
    myd: '本问卷旨在调查您对课程的满意度',
		questionnaireDescription: "问卷说明",
		pleaseEnter: "请输入",
		theNumberBetween: "之间的数字",
		surveyAnswer: "问卷回答",
		viewSurvey: "查看问卷",
		other: "其他",
		tip: '请将带*号的必答题答完之后提交问卷',
		pleaseFillScore: "请填写分值范围内的分数！",
		confirmSubmit: '确认提交问卷？',
		thankYouForSurvey: "感谢您的及时反馈，谢谢！",
		rateLevel1: "不满意",
		rateLevel2: "不太满意",
		rateLevel3: "一般",
		rateLevel4: "比较满意",
		rateLevel5: "非常满意"
	},
	my: {
		lljl: "浏览记录",
		endCourse: "我的-已结束课程",
		myMsg: "我的-我的消息",
		myMsgUnit: "条新消息",
		technicalHelp: "技术帮助",
		setting: "设置",
		technicalPhone: "技术电话",
		workingHours: "工作时间",
		enquireEmail: "咨询邮箱",
		multiLanguage: "多语言",
		neoDownload: "neo安装下载",
		accountSettings: "账户设置",
		information: '我的信息',
		userHead: "用户头像",
		replaceHead: "更换头像",
		userNickName: "昵称",
		userName: "姓名",
		userPassword: "密码",
		userMobile: "手机",
		userEmail: "邮箱",
		userWX: "微信",
		userSex: "性别",
		man: "男",
		woman: "女",
		userAddress: "地区",
		userDepart: "部门",
		userPasswordTip: '密码已设置',
		userMobileTip: '手机已绑定',
		userEmailTip: '邮箱已绑定',
		userWXTip: '微信已绑定',
		userWXTip1: '微信未绑定',
		userSexTip: '性别已设置',
		userSexTip1: '性别未设置',
		userAddressTip: '地区未设置',
		userAddressTip1: '地区已设置',
		userDepartTip: '部门未设置',
		userDepartTip1: '部门已设置',
		pleaseInputNickName: "请输入昵称",
		uploadFormatIsIncorrect: "上传格式不正确，请重新上传",
		uploadSizeIsOver: "上传图片大小不能超过4M",
		yourBrowersNotSupport: "您的浏览器不支持图片上传，请升级您的浏览器",
		trainingStart: "培训开始：",
		trainingEnd: "培训结束：",
		classStartTime: "开课时间：",
		courseLevel: "课程难度：",
		courseTeacher: "课程讲师：",
		surplusQuota: "剩余名额：",
		unlimited: "不限",
		inCutting: "正在裁剪中"
	},
	setting: {
		Newpassword: '设置新密码',
		setting: "设置",
		topTitle: "账号设置",
		face: "头像",
		nickName: "昵称",
		name: "姓名",
		password: "密码",
		toSet: "去设置",
		setted: "已设置",
		mobile: "手机",
		email: "邮箱",
		wechat: "微信",
		sex: "性别",
		male: "男",
		female: "女",
		address: "地区",
		department: "部门",
		uploadPicWarning: "您的浏览器不支持图片上传，请升级您的浏览器",
		modifySuc: "修改成功",
		modify: "修改",
		modifyInputPlaceholder: "请输入",
		clearCache: "清除缓存",
		updateVersion: "版本更新",
		clearCacheConfirm: "确认清除缓存？",
		logoutConfirm: "确认退出登录？",
		confirmCancelEdit: "确认取消本次修改？",
		confirmSaveEdit: "确认保存本次修改？",
		modifyNickname: '昵称',
		modifyGender: '性别',
		modifyRegion: '地区',
		modifyDepartment: '部门'

	},
	lang: {
		zh: "中文-简体",
		en: "English",
		tw: "中文-繁體",
		languageTips: "切换语言",
		changeLanguage: "确定切换语言吗？"
	},
	menu: {
		studycenter: "上课中心",
		mine: "我 的",
		accountSettings: "账号设置",
		endedCourse: "已结束课程",
		notice: "我的消息"
	},
	upload: {
		uploadComplete: "上传完成",
		uploading: "文件上传中...",
		close: "关 闭"
	},
	neo: {
		setup: "扫描安装neo",
		ScanQR: "使用手机扫描二维码",
		coursewareStudy: "课件学习",
		toDownload: "去下载",
		finishTips1: "下载提示",
		finishTips2: "入学测试已完成，请下载NEO AI学习课件。",
		userAccount: "账号：",
		userPwd: "密码：",
		finishTip3: "( 注意：账号需等待教务激活后使用 )"
	},
	dyned: {
		clickDownload: "点击下载Dyned",
		hasDownload: "已下载，去Dyned学习",
	},
	IM: {
		UnsupportedFileType: "文件格式不符合要求!",
		FileLarge: "文件太大，请重新选择!",
		pic: "[图片]",
		other: "[其他]",
		exerciseTaskTips: "课前预习对于上课非常必要，赶紧完成自学任务吧",
		homeworkTaskTips: "您有一份作业待完成，是否立即完成？",
		doLater: "稍后去做",
		doNow: "马上去做"
	},
	certificate: {
		targetCertificate: "目标证书",
		targetLevel: "目标等级",
		myCertificate: "我的成就",
		certificateLevel: "证书等级",
		noCertificate: "暂未获取证书，加油哦！",
		certificate: "证书",
		medal: "勋章",
		integral: "积分",
		scholarship: "奖学金",
		certificateStandardIntro: "获得证书标准说明",
		finalExamScore: "结业测试得分",
		num: "个",
		minuteUnit: "分钟"
	},
	binding: {
		wxBinding: "微信绑定",
		unBound: "解除绑定",
		goBinding: "去绑定",
		hasBinding: "已绑定",
		openSweep: "打开微信扫一扫",
		unBoundTitle: "解绑确认",
		unBoundMsg: "确认当前账号与该微信号解绑",
		unBoundConfirm: "确定解绑",
		unbindingSuccess: "解绑成功",
	},

	scholarship: {
		webTips: "请到岱恩教育App领取奖学金",
		buKeTips: "请到岱恩教育App兑换补课卷",
		awardCode0: '人工发放',
		awardCode1: '首次完成任意课程的学前指导',
		awardCode2: '完成任意课时且在课时结束后的24小时内评价',
		awardCode3: '教务推送的跟进反馈在24小时内完成',
		awardCode4: '竞赛获奖前三名',
		awardCode5: '获得任意一个课程的证书',
		awardCode6: '完成任意项目的达标要求',
		awardCode7: '引购套餐',
		awardCode8: '转发评价',
		awardCode9: '转发证书',
		awardCode10: '转发竞赛',
		awardCode11: '竞赛获奖',
		awardCode12: '完成证书/项目达标/课程中期 评价',
		awardCode13: '绑定手机号',
		awardCode14: '浏览公众号引导页',
		awardCode15: '提交需求调研',
		awardCode16: '积分兑换',
		awardCode17: '购买套餐赠送',
		awardCode18: '完成轻课奖励',
		awardCode19: '完成直播奖励',
		awardCode20: '加入畅学项目附赠',
		awardCode21: '大众用户注册赠送',
		awardCode22: '完成阅读文章奖励',
		awardCode23: '悬赏任务奖励',
		awardCode24: '参与问卷活动中奖',
		awardCode25: '连续签到',
		awardCode26: '邀请好友PK的获胜方',
		awardCode27: '用户首次授权登录',
		awardCode28: '邀请新用户授权登录',
		awardCode29: '加入企业时附赠',
		awardCode30: '完成学习计划',
		awardCode31: '用户级别提升',
		awardCode32: '完成专题',
		awardCode33: '口语评测',
		awardCode34: 'app首次登录',
		awardCode35: '奖学金充值',
		awardCode36: '泛读小程序打卡',
    awardCode37: '填写课程问卷调查',
		exchangeCode0: '奖品',
		exchangeCode1: '购买课程套餐抵扣',
		exchangeCode2: '沙龙课抵扣',
		exchangeCode3: '兑换积分',
		exchangeCode4: '训练营',
		exchangeCode5: '打赏',
		exchangeCode6: '评分畅读',
		exchangeCode7: '重置专题',
		exchangeCode8: '兑换专题',
		exchangeCode9: '兑换评分次数',
		exchangeCode10: '竞赛报名',
		exchangeCode11: '解锁隐藏文章',
		exchangeCode12: '订阅泛读专题/文章',
		exchangeCode13: '互动答疑消费',
		exchangeCode14: '订阅视频课',
		exchangeCode15: '订阅轻课',
		exchangeCode16: '订阅阅读精读',
		exchangeCode17: '畅学卡5折券',
		ttltitle: '天天练中获取',
		ttltip0: '完成专题',
		ttltip1: '按照专题设定',
		ttltip2: '连续签到',
		ttltip3: '每连续签到1、3、7天可分别获得1、2、4奖学金',
		ttltip4: '邀请新用户授权登录',
		ttltip5: '用户首次登录授权',
		ttltip6: '邀请好友pk的获胜方',
		ttltip7: '完成学习计划',
		ttltip8: '完成企业时附赠',
		ttltip9: '用户级别提升',
		ttltip10: '按照计划设定',
		ttltip11: '按照附赠设定',
		ttltip12: '根据不同级别设定',
		jxjtitle: '岱恩语培中获取',
		jxjdq: '奖学金即将到期',
		oneOnOne: '仅限一对一 1节',
		smallGroup: '仅限小班课奖学金',
		canuseScholarship1: '可用积分',
		title1: '奖学金兑换积分',
		title2: '积分兑换奖学金',
		title3: '积分和奖学金可以手动输入',
		dhbtn: '兑换',
		sx1: '获取方式',
		sx2: '使用方式',
		conB: '确定',
		lsee: '我知道了',
		scholarshiptitleGQ: '过期记录',
		scholarshiptitle1: '获取记录',
		scholarshiptitle2: '使用记录',
		scholarshiptitle3: '已累计获取',
		scholarshiptitle3_: '已累计获取',
		scholarshiptitle4: '筛选',
		scholarshiptitle5: '获取方式',
		scholarshiptitle6: '岱恩英语天天练奖学金获取方式',
		scholarshiptitle7: '获取记录',
		scholarshiptitle8: '使用记录',
		scholarshiptitle9: '已累计使用',
		scholarshiptitle9_: '已累计使用',
		scholarshiptitle10: '已过期',
		reward: '领取奖励',
		myScholarship: '我的奖学金',
		myJf: '积分',
		exchangePrizes: '奖学金商城',
		togetScholarship: '待领取',
		courseExchange: '课程兑换',
		exchangeRecord: '兑换记录',
		guidanceExamTips: '别忘了完成学前指导哦，完成之后可以获得奖学金！',
		moreRewards: '更多奖励任务',
		reward1: '首次完成任意课程的学前指导',
		reward2: '完成任意课时且在课时结束后的24小时内评价',
		reward3: '完成任意项目的达标要求',
		reward4: '教务推送的跟进反馈在24小时内完成',
		reward5: '获得任意一个课程的证书',
		reward6: '竞赛获奖',
		reward7: '购买套餐赠送',
		reward8: '完成证书/项目达标/课程中期 评价',
		reward9: '轻课奖励',
		reward10: '直播奖励',
		reward111: '悬赏任务奖励',
		scholarship: '奖学金',
		morePrizes: '更多奖品敬请期待',
		viewExchangeRecord: '查看兑换记录',
		canuseScholarship: '可用奖学金',
		exchangeSuccess: '奖品兑换成功',
		youCanSee: '您可在兑换记录中查看',
		confirmExchangePrizes: '是否确定兑换？',
		hasScholarship: '奖学金已获',
		getIt: '领取',
		tabelTime: '时间',
		tabelName: '名称',
		tabelNum: '数目',
		toView: '去查看',
		reward11: '部分渠道获取的奖学金有使用期限，请在期限结束前使用，逾期将无法使用。即将过期的奖学金，在当前页面上有过期提醒，请注意查看。',
		// shareOne: "分享一个",
		// littleSecrets: "小秘密",
		// firstForward: ", 首次转发至朋友圈后, ",
		// getMoreRewards: "可获得更多奖励哦！",
		getSuccess: '领取成功',
		deposited: '已存入',
		account: '账户',
		gotoForward: '去转发',
		clickToLook: '点击查看',
		getOneReward: '您获得一次奖励机会',
		// firstForward1: "首次转发至朋友圈后，可",
		// getMoreRewards1: "获得更多奖励哦！",
		gotoReward: '立即领取',
		congratulations: '恭喜',
		forwardToShowOff: '转发到朋友圈炫耀一下吧',
		toUse: '去使用',
		explain: '说明：',
		selectMakeUpClass: '请选择想要补课的课时：',
		selectMakeUpCourse: '请选择想要补课的课程：',
		makeUpSuccess: '补课操作完成',
		clickHere: '点击这里查看',
		absentLessonChanged: '补课时间已预约',
		scholarshipNotEnough: '奖学金不足，无法兑换',
		cannotMakeUp: '您尚未缺席过任何课时或补课券与缺席课时的长不匹配，不可兑换该补课券',
		bookNumAdd: '您的选课次数增加1次',
		dxcs: '导学测试',
		kspj: '课时评价',
		fkgj: '反馈跟进',
		kcs: '获得课程证书',
		xmdb: '项目达标',
		jshj: '竞赛获奖',
		tczs: '套餐购买赠送',
		pj: '完成证书/项目达标/课程中期 评价',
		jk: '轻课奖励',
		zb: '直播奖励',
		jp: '奖品',
		dk: '购买课程套餐抵扣',
		slk: '沙龙课抵扣',
		dh: '兑换积分',
		Switch: '转换',
		tip1: '请输入数字',
		tip2: '小数点保留两位',
		tip3: '请输入大于0的数字',
		tip4: '请输入大于2的整数',
		tip5: '此次兑换消耗',
		tip6: '必须是大于0的整数',
		qb: '全部',
		jszt: '解锁专题',
		jsbm: '竞赛报名',
		czzt: '重置专题',
		dhkc: '兑换课程',
		gmlypf: '购买评分机会',
		lypf: '录音评分',
		qd: '每日签到',
		sqdl: '邀请新用户授权登录',
		scdl: '用户首次授权登录',
		pkhs: '邀请好友PK的获胜方',
		wcjh: '完成学习计划',
		fz: '各类形式附赠（包括企业附赠、购买套餐附赠等）',
		jxjdh: '奖学金兑换',
		ny: '您有',
		jfjjdq: '积分即将到期',
		jxjjjdq: '奖学金即将到期',
		ljsg: '立即使用'
	},
	label: {
		setTags: "设置标签",
		defaultTags: "默认标签",
		selectTags: "选择标签",
		selectInterested: "选择你感兴趣的其他内容：",
		labelNote: "注：选择过标签后无法更改",
		canSelectLimit: "最多可以选择",
		canSelectLimitUnit: "个标签",
		canSelectLimitUnits: "个标签",
		selectTagsPlease: "请选择标签",
		selectTagsConfirm: "选择标签后无法更改，是否确认选择？",
		setComplete: "设置成功",
		selectTips1: "您还可以选择 ",
		selectTips2: " 个标签"
	},
	level: {
		selectLevel: "选择等级",
		currentLevel: "当前目标等级",
		historyLevel: "历史目标等级",
		todoTest: "待测试"
	},
	exam: {
		Evaluationoftest: '考试评价',
		appointmentExam: "预约考试",
		CancelExam: '取消预约',
		appointmentExamconfirm: "预约考试",
		Waiting: '等待评价',
		Results: '查看评价',
		Uncompleted: '考试缺席',
		examTip01: '时间未到',
		examTip02: '老师正在对你的口语能力进行评价',
		examTip03: '口语测试需开启摄像头',
		examTip04: '考试已结束',
		examTip05: '你的考试未完成，如有疑问，请联系教务反馈',
		examReminder: "考试提醒",
		joinExam: "进入考试",
		examTime: "考试时间：",
		start: "开始",
		examNotStart: "考试未开始，请等待",
		examfinished: "考试已结束",
		examTips: "考试须知",
		examTips1: "1、进入考试后，开始计算考试时间，考试时间结束后会自动交卷，请注意考试时间。",
		examTips2: "2、考试过程中无法查看习题答案，考试结束后无法查看试卷。",
		examTips3: "3、考试结束后，请在我的--我参与的里查看考试得分",
		competition: "竞赛",
		examTitle: "考试",
		examScore: "考试得分：",
		toBeCorrect: "待批改",
		level: "等级",
		reset: "已重置",
		clickStartExam: "点击开始考试"
	},
	smallClass: {
		themeTab1: "按时间",
		themeTab2: "按主题",
		hasApplyed: "已预定",
		hasBookedFull: "已订满",
		lessonTeacher: "讲师",
		duration: "时长",
		minuteUnit: "分钟",
		intro: "介绍",
		consume: "消耗",
		bonuses: "课次",
		enbonuses: "",
		seedetail: "查看详情"
	},
	favoriteTeacher: {
		favoriteTeacher1: '优选老师',
		szyx: '已将该老师加入我的优选老师名单',
		qxyx: '已将该老师移除我的优选老师名单',
		select: '加入我的优选老师名单',
		cancelSelection: '取消',
		set: '已成功设为优选老师',
		cancel: '取消设为优选老师',
		addTeacher: '已添加到我的不推荐老师名单',
		cancelTeacher: '取消我的不推荐老师名单',
		mloveTeacher: '我的偏好老师',
		mloveTeacher1: '教师发音偏好',
		jsfy: '教师发音',
		ktfw: '课堂氛围',
		qsys: '轻松灵活',
		rzys: '严肃认真',
		skfg: '授课风格',
		tip: 'Tips：自选课中，优先匹配符合您的偏好的老师',
		clear: '清除所有',
		zsxq: '至少选择一项',
		zsph: '设置我的偏好',
		phls: '偏好老师',
		videoLesson: '支持视频上课',
		audioLesson: '支持音频上课'
},
	robot: {
		nodata0: '小智发现暂无会话哦',
		nodata1: '小智发现暂无新的通知哦',
		nodata2: '小智发现暂无上课通知哦',
		nodata3: '小智发现暂无预习通知哦',
		nodata4: '小智发现暂无作业通知哦',
		nodata5: '小智发现暂无评价通知哦',
		nodata6: '小智发现暂无考试通知哦',
		nodata7: '小智发现暂无订课通知哦',
		nodata8: '小智发现暂无活动通知哦',
		nodata9: '小智发现暂无其他通知哦',
		pic: '[图片]',
		sound: '[语音]',
		qt: '[其他]',
		sp: '[视频]',
		loading: '加载中',
		delMsg: '是否删除信息',
		hddd: '已经到底了，不能滑动了哦',
		qklb: '是否确认清空当前列表？',
		xxx: '条新消息',
		notifications: '通知',
		conversations: '会话',
		unread: '未读',
		yx: '预习',
		status1: '未完成',
		status2: '已完成',
		status3: '待批改',
		status4: '已批改',
		status5: '未领',
		status6: '已领',
		status7: '未获取',
		status8: '已获取',
		status9: '学生缺席',
		status10: '教师缺席',
		status11: '学生缺席补课',
		status12: '教师缺席补课',
		status13: '未评',
		status14: '已评',
		Details: '详情',
		name: '小智',
		help: '帮助',
		set: '设置',
		cleartitle: '清除聊天记录',
		tip1: 'Hello!我是你的学习AI助理小智，从今天开始密切关注你的学习哦！不要偷懒，让我们每天有一点进步，有学习上的问题可以随时问我',
		tip2: '下面请跟随小智做一些设置，以便更好的为你服务哦！',
		g5title: '开始5.0指引',
		sq: '获取授权',
		sqtitle: '现在小智需要你的授权，才能更好的发挥实力',
		record: '录音',
		tip3: '用于提供语音输入和语言识别功能',
		tip4: '通知',
		tip5: '用于及时推送小智新功能升级、学习相关的内容',
		tip6: '请务必同意调用以上权限，否则将导致这些功能无法正常使用，但不影响基本功能的使用。您可以前往“设置”>"权限管理"，选择关闭以上权限调用以撤回您的同意',
		tip7: '您没有授权麦克风权限,点击下方开启授权',
		tip8: '您没有授权通知权限,安卓机此权限请去系统应用管理打开,点击下方开启授权',
		sq1: '为了更好的使用，我们需要一些权限',
		sq2: '用于提供语音输入和语言识别功能',
		sq3: '开启权限',
		xxysx: '消息已失效',
		xxyc: '消息异常'
	},
	dialogue: {
		XPJ: '写评价',
		dialogue: '设置',
		delword: '确定后，将删除你主动发起的聊天记录',
		delSuss: '清除成功',
		word: '你可以去技能界面查看小智的技能哦',
		nospeach: '您还没有说话哦',
		bindSuss: '已绑定成功',
		haschangeBandage: '你当前账号已进行过绑定哦',
		bindBad: '你当前的微信账号已绑定过其他账号，绑定失败！',
		morning: '早上好',
		afternoon1: '下午好',
		afternoon2: '中午好',
		evening: '晚上好',
		stillAwake: '您还没睡呢',
		askword: '您可以这样问我',
		Skills: '技能表',
		Change: '换一批',
		speak: '请开始说话',
		dk1: '"订课"',
		dk2: '"课程表"',
		dk3: '"请假"',
		dk4: '"查成绩"',
		zx1: '"自学"',
		jf: '"积分"',
		yhq: '"优惠券"',
		jxj: '"奖学金"',
		word1: '点击 说话',
		word2: '点击 结束',
		youask: '你的回复...',
		youask1: '你可以这样问我',
		exTile: '考试标题',
		kcTile: '课程名称',
		ksTile: '课时名称',
		openPaper: '打开试卷',
		cando: '我会做的事可多了：提醒你预习、上课、写作业、评价，我还有许多其他的技能，你可以在手机中查看我的全部技能哦',
		admissionTest: '为你找到当前可做的“入学测试”试卷',
		noadmissionTest: '你当前暂无“入学测试”要做哦',
		LevelTest: '为你找到当前可做的“水平测试”试卷',
		noLevelTest: '你当前暂无“水平测试”要做哦',
		phaseTesting: '为你找到当前可做的“阶段测试”试卷',
		nophaseTesting: '你当前暂无“阶段测试”要做哦',
		completionTesting: '为你找到当前可做的“结业测试”试卷',
		nocompletionTesting: '你当前暂无“结业测试”要做哦',
		testing: '为你匹配到当前最近的一次“测试”',
		notesting: '你当前暂无“测试”哦',
		exam: '为你匹配到当前最近的一次“考试”',
		noexam: '你当前暂无“考试”哦',
		course: '正在为你打开“课程表”页面',
		interactiveClassroom: '正在为你打开互动课堂',
		noInteractiveClassroom: '你当前暂无课程要上哦',
		preview: '为你找到当前可做的“预习”试卷',
		nopreview: '你当前暂无课程可预习哦',
		homework: '为你找到当前可做的“作业”试卷',
		nohomework: '你当前暂无作业哦',
		exchangePrizes: '正在为你打开“补课券”页面',
		absentLesson: '如果你想补课，需去补课券页面兑换补课券哦，正在为你打开“补课券”页面',
		noabsentLesson: '你当前无需补课哦',
		grades: '正在为你打开最近的一次成绩页面',
		nogrades: '你当前暂无成绩哦',
		classbook: '正在为你打开“订课”列表页面',
		hasclassbook: '您是要订哪门课程呢',
		noclassbook: '正在为你打开“订课”列表页面',
		appraisals: '已为你找到当前可写的评价',
		noappraisals: '你当前暂无评价可写哦',
		lookReviews: '正在为你打开最近的一次评价记录',
		nolookReviews: '你还暂未收到任何评价呢',
		absence: '正在为你打开“请假”',
		noabsence: '你当前暂无可请假的课哦',
		daionMall: '正在为你打开“岱恩商城”',
		oralTraning: '正在为你打开天天练小程序',
		achievement: '正在为你打开“成就”页面',
		noachievement: '你还没有获得任何成就哦',
		certificate: '正在为你打开“证书”页面',
		nocertificate: '你还没有获得任何证书哦',
		myScholarship: '正在为你打开“奖学金”页面',
		integral: '正在为你打开“积分”页面',
		coupon: '正在为你打开“优惠券”页面',
		binding: '你当前账号已进行过绑定哦',
		hasbinding: '已换绑成功哦',
		nohasbinding: '换绑失败请联系教务',
		unknown: '小智没听清你的指令，请重说一遍',
		relax: '我休息一会儿',
		xiaozhi: '我来了，请问你有什么需要？',
		voiceplayback: '语音播放已打开',
		trainingCamp: '正在为你打开“训练营”页面',
		notrainingCamp: '你当前暂无训练营可参与哦',
		starTrainer: '正在为你打开“直播”详情页面',
		nostarTrainer: '你当前暂无直播课可报名哦',
		podclass: '正在为你打开“轻课星球”列表页面',
		nopodclass: '你当前暂无轻课可订阅哦',
		searchWord: '正在为你跳转',
		nosearchWord: '当前词库暂无搜索结果哦'
	},
	ability: {
		title: '快来试试小智的各种技能吧',
		Skill: '技能示例',
		question1: '测试、考试相关，试试对我说：',
		question2: '上课、补课、查课表、成绩相关，可以这么说',
		question3: '订课、评价、请假相关的，试试对我说：',
		question4: '奖学金、积分、优惠券相关的，可以这么说：',
		question5: '天天练，试试对我说：',
		question6: '绑定相关的，可以这么说：',
		question7: '常见语音问题',
		ceshi1: '"测试/考试"',
		ceshi2: '"入学测试/水平测试"',
		ceshi3: '"阶段测试"',
		ceshi4: '"结业测试"',
		ceshi5: '"自学/预习"',
		ceshi6: '"作业"',
		sk1: '"上课"',
		sk2: '"补课"',
		sk3: '"补课券"',
		sk4: '"查看课程表"',
		sk5: '"查成绩"',
		sk6: '"成就/证书"',
		dk1: '"订课/选课"',
		dk2: '"写评价"',
		dk3: '"查看评价"',
		dk4: '"请假/取消"',
		jsj1: '"查看奖学金"',
		jsj2: '"查看积分"',
		jsj3: '"查看优惠券"',
		jsj4: '"天天练"',
		bd1: '绑定',
		ss: '试试',
		tip1: '常见语音问题',
		tip2: '小智识别不了我说的话/识别错误？',
		see: '查看',
		question8: '训练营、轻课星球/微课，试试对我说：',
		xly1: '"训练营"',
		xly2: '"直播"',
		xly3: '"轻课星球/微课"',
		cckys: '查词，试试跟我说：',
		ci1: '"查单词 发音"',
		ci2: '"查词组 在哪里"',
		ci3: '"查词汇 苹果"',
		ci4: '"查词 地图"'
	},
	quesiton: {
		name: '常见问题',
		title1: '使用方法',
		title2: '提示',
		tip1: '开启麦克风权限 > 点击小智头像或者摇一摇手机进入对话页面，根据底部话筒指示 > 点击语音按钮即可说话>点击结束即可发送。',
		tip2: '使用语音功能没反应，可能的原因有：',
		tip3: '1. 使用时，靠近话筒，语速适中',
		tip4: '2. 识别错误时，可使用多轮对话，修正识别错误的文字。例如：“评价+查/写”',
		tip7: '1. 没有开启麦克风权限',
		tip6: '2. 麦克风被其他音频播放器占用（如后台有音乐播放）',
		tip5: '上一页',
		next: '下一页',
		title3: '原因',
		title4: '如何使用语音唤醒',
		title5: '小智识别不了我说的话/识别错误？',
		tip9: '在环境嘈杂、重口音等条件下，小智语音可能识别不准。'
	},
	RobotCourse: {
		Classschedule: '课程表',
		Selected: '选中',
		UpcomingClass: '最近有课',
		ScheduledClasses: '有课',
		Classes: '课'
	},
	learning: {
		name1: '畅学',
		name2: '上课中心',
		ceshi: '水平测试',
		ceshi1: '学习计划',
		studyPlan: '定制学习计划',
		trainingCamp: '训练营',
		ceshiBtn: '前往测试',
		levelHint2: ' 人已完成测试',
		lessonProgress: '进度',
		major: '你可能感兴趣的其他课程',
		classtime: '总课次',
		period: '学习周期',
		bespokenum: '可预定次数',
		paln1: '今日已学/分钟',
		paln2: '学习得分/分',
		paln3: '连续打卡/天',
		jrzb: '进入直播',
		qxx: '去学习',
		tab1: 'AI天天练',
		tab2: '名师直播',
		tab3: '轻课星球',
		tab4: '精选阅读',
		tab5: '视频好课',
		zxdf: '已得学分',
		zxf: '总学分',
		fjs: '分解锁',
		title1: '每日一句',
		hint1: '名言美句等你来学',
		title2: '岱恩i挑战',
		hint2: '和小伙伴一起练口语',
		grades1: '学秀',
		grades2: '学霸',
		grades3: '学神',
		grades4: '学圣',
		exitApp: '您再点一次将退出APP',
		c: '次',
		ckgd: '查看更多',
		hyp: '换一批',
		zjgx: '最近更新',
		bzxicc: '本周学习时长',
		bzhdxf: '本周获得学分',
		bzhhdjj: '本周获得奖学金',
		nhkus: '您还可以这样学'
	},
	mc: {
		see: '查看',
		ydy: '人已订阅',
		microCourse: '轻课星球',
		detail: '详情',
		intro: '简介',
		discuss: '讨论',
		evaluate: '轻课评价',
		pinputi: '请输入标题',
		seo: '搜索',
		all: '全' + '\xa0\xa0' + '部',
		dy: '订' + '\xa0\xa0' + '阅',
		g: '共',
		qs: '期',
		iswj: '已完结',
		tg: '团购',
		yg: ' 人已购',
		t: '团',
		c: '促',
		jd: '进度:',
		day: '天',
		hasyx: '学习有效期:',
		xq: '轻课详情',
		kcyxq: '课程有效期',
		jl: '奖励',
		jxj: '奖学金',
		hfsc: '学习本课程预计花费时长:',
		scgz: '课程时长',
		sc: '预计花费时长包含音视频学习和巩固练习（如有巩固练习）。学习时长因人而异，请合理安排学习时间哦!',
		gz: '奖励规则',
		title: '完成已完结的轻课内全部课时学习，获得奖金。',
		qd: '确定',
		ml: '目录',
		pj: '评价',
		qpj: '去评价',
		gm: '立即购买',
		jq: '领券',
		lyhj: '领取优惠券',
		yhj: '元优惠券',
		off: '折',
		qdl: '恭喜，抢到了',
		ljlq: '立即领取',
		lqcg: '领取成功',
		tgy: '人团',
		money: '元',
		s: '省',
		tghd: '团购活动',
		tgj: '团购价',
		qrct: '是否确定参团',
		kt: '我要开团',
		qkgm: '请先购买本课，才能继续学习哦',
		xm: '限免',
		ms: '秒杀',
		gxz: '更新中',
		st: '试听',
		noyhj: '无可选优惠券',
		kx: '张可选',
		dk: '奖学金抵扣',
		dkje: '请输入抵扣金额',
		jfdhb: '积分兑换',
		name: '姓名',
		phone: '手机号',
		tilte: '购买当前课程套餐最多使用',
		hint1: '我已阅读并同意',
		hint2: '《岱恩课程服务协议》',
		hint3: '并确认课程的真实性，同意支付报名费',
		yjxj: '元奖学金',
		kcxj: '课程已下架',
		Ahas: '已有',
		nowday: '今日到期',
		noexchage: '支付金额不需要兑换奖学金',
		dhcg: '兑换成功',
		qxsc: '取消收藏成功',
		sccg: '收藏成功 可在我的-收藏中查看',
		gxqd: '恭喜，抢到了',
		ymsq: '请关闭页面重新进入授权',
		share1: '限时优惠！速速来抢！',
		share2: '跟我一起拼团吧！',
		share3: '邀请你一起学习',
		yhsx: '当前限时优惠时间已过，请使用原价进行支付',
		ctes: '成团人数',
		ren: '人',
		conkt: '是否确定开团?',
		conct: '是否确定参团?',
		tz: '团长',
		myct: '我要参团',
		gq: '该团已过有效期，请参与其他拼团',
		userAgreementCheck: '请阅读并同意《岱恩课程服务协议》',
		jxjhint: '奖学金金额发生改变 请刷新页面 重新购买',
		bmcg: '订阅成功',
		gmcg: '购买成功',
		dqyy: '你当前拥有',
		ljjf: '累计积分',
		zfsy: '本次支付还可以使用',
		jfdhc: '积分兑换成',
		kdh: '可兑换',
		isdh: '是否确认兑换？',
		jxjdk: '奖学金可抵',
		bmjz: '报名截止',
		yxj: '已下架',
		cytg: '参与团购',
		tgjd: '团购进度',
		jzsj: '截止时间',
		jrzbj: '进入直播间',
		xsyh: '限时优惠',
		totle: '合计',
		wxzf: '微信支付',
		gmkg: '购' + '\xa0\xa0' + '买',
		wks: '未开始',
		tgkg: '团' + '\xa0\xa0' + '购',
		phoneV: '手机号验证码',
		fsyzm: '发送验证码',
		yzmsb: '验证码发送失败，请重试',
		yzmfs: '验证码已发送，请注意查收',
		bfspky: '部分商品可用',
		m1: '满',
		sy: '使用',
		xsmf: '限时免费',
		jljs: '距离结束',
		rct: '人成团',
		zjcy: '直接参与 快速成团',
		nmuesr: '匿名用户',
		jjs: '距结束',
		qct: '去参团',
		less: '差',
		xzyhj: '选择优惠券',
		nsyyhj: '不使用优惠券',
		video: '影',
		audio: '音',
		yhq: '优惠券',
		rdy: '人订阅',
		xxjl: '学习奖励',
		yhdk: '优惠抵扣',
		bcdk: '本次抵扣',
		xqjs: '详情介绍',
		kslb: '课时列表',
		kcmu: '课程目录',
		pl: '评论',
		spkP: '搜索系列课标题、讲师姓名',
		ztspk: '主题视频课',
		bs: '倍速',
		lx: '练习',
		sfdykc: '您尚未订阅当前课程，是否现在订阅？',
		zbdy: '暂不订阅',
		ljdy: '立即订阅',
		xxdy: '当前视频课需要订阅后学习哦',
		chapter: '篇'
	},
	column: {
		name: '专栏详情',
		xxjd: '学习进度'
	},
	live: {
		zjls: '主讲老师',
		isApply0: '可预约',
		isApply1: '已预约',
		isApply2: '已约满',
		zbsj: '直播时间:',
		ryx: '人已学',
		teacher: '主讲老师',
		more: '更多',
		zbjj: '直播简介',
		kcap: '课程安排',
		yx: '设为关注',
		qxyx: '取消关注',
		hf: '查看回放',
		name: '名师直播详情',
		hint1: '直播回放生成中，请稍候',
		hint2: '当前直播已超过回看时间',
		hint3: '只能进入最近的一节未开始的课时哦',
		hint4: '当前直播课不允许回看',
		gzcg: '关注成功',
		title: '参与当前直播的所有课时学习后可获得奖励',
		ddque: '订单确认',
		name1: '名师直播',
		jpls: '金牌教师',
		ybm: '已报名',
		rybm: '人已报名',
		xxgjc: '向下更精彩',
		jzsj: '截止时间',
		jrapp: '请进入app学习'
	},
	teaDetail: {
		teacherDetails: '老师详情',
		introduction: '介绍',
		evaluation: '评价',
		relatedCourses: '相关课程',
		personalProfile: '个人简介',
		teacherExperience: '教师经历',
		certificate: '荣誉证书',
		noTeaDetail: '暂无该老师详细介绍'
	},
	share: {
		user: '岱恩用户',
		joinMe: '我正在学习，邀请您一起加入～',
		QRcode: '长按识别二维码',
		word: '岱恩精品课程，邀你一起学！',
		word1_1: '岱恩精品',
		word1_2: '课程',
		word1_3: '邀你一起学！',
		word2_1: '岱恩精品课程',
		word2_2: '邀你一起学！',
		Share: '从这里可以分享出去哦',
		wx: '微信',
		frend: '朋友圈',
		Im: '我是'
	},
	MCLesson: {
		lessonDetail: '课时详情',
		completed: '次已学',
		Progress: '进度',
		teacher: '老师',
		wenti: '有什么问题，提给老师吧',
		nodataTip: '暂时还没有人提问抢个沙发吧',
		enterTip: '请输入要提问的信息！'
	},

	trainingCampDetail: {
		trainingCampDetail: '训练营详情',
		trainingCampIntroduction: '训练营介绍',
		free: '免费',
		share: '分享活动',
		signUpNow: '立即报名',
		addStudyAdvisor: '添加课程顾问',
		signedSuccess: '报名成功',
		seconds: '后自动跳转至添加课程顾问页面',
		wjfwfbm: '您当前的账号没有积分，无法报名',
		jf: '积分',
		jxj: '奖学金',
		daydayStudy: '岱恩英语天天练习'
	},
	levelTest: {
		title1: '测试基于',
		title: '欧洲语言通用标准',
		title3: '制定',
		title2: '严格保证测试结果的准确性',
		yy: '已有',
		rwccs: '人完成水平测试',
		Instruction: '特别提示',
		tip1: ' 1、完成全部测试需要约15分钟，请预留好时间，保持测试流程连贯；',
		tip2: ' 2、测试过程中会有口语测试，请打开麦克风。',
		tip3: ' 3、为保证良好的测试环境，建议佩戴耳机进行测试。',
		Starttesting: '开始测试',
		mkfqx: '请开启麦克风权限',
		rxcj: '系统发现您之前已经做过入学，已为您自动获取测试成绩为',
		nobingWx: '您暂未绑定微信',
		tips4: '跳过测试，直接进入学习偏好设置'
	},
	lessonAudio: {
		title: '课程音频'
	},
	TTlexam: {
		title: '您当前的英语能力水平处于',
		ozty: '欧洲语言通用标准',
		jb: '级别',
		cancs: '您当前的英语水平可以做',
		g: '共',
		tm: '题',
		clear: '清除',
		tj: '提交',
		yyspcs: '英语水平测试',
		tjcg: '提交成功',
		tjsb: '提交失败',
		qktm: '清空题目',
		xztkt: '选择填空题',
		tkttitle: '听原音，选择正确的选项填入横线上',
		tkttitle1: '选择正确的选项填入横线上',
		txda: '请填写答案',
		hasLimit: '原音播放次数已达上限',
		mst: '默述题',
		mstbjyyc: '本句部分内容已隐藏，请根据原音进行跟读',
		mstbjyyc1: '本句已全部隐藏，请根据原音进行跟读',
		mstbjyyc2: '本句已隐藏，请根据原音进行跟读',
		mstvideo: '听原音后，点击下方录音按钮开始答题',
		ksly: '开始录音',
		jsly: '结束录音',
		djjsly: '点击波纹结束录音',
		qbfly: '请先播放原音后再开始录音哦',
		txt: '听写题',
		mxcl: '听原音，将听到的原音默写出来',
		tdscda: '点击开始输入听到的答案',
		txda1: '请填写答案',
		tkt: '填空题',
		tyypx: '听原音，根据原音拼写',
		kbcsdnr: '在空白处填入适当的内容',
		pxt: '排序题',
		pxttltle1: '听原音，将下列单词按原音顺序排列',
		pxttltle2: '将下列单词按顺序排列',
		txttltle2: '点击单词或将单词拖入此区域',
		dtsj: '答题时间已到',
		sb: '启动录制接口失败',
		csjg: '测试结果'
	},
	myword: {
		del: '删除',
		myword: '我的单词本',
		playAll: '播放全部',
		review: '开始复习',
		setting: '设' + '\xa0' + '置',
		definition: '单词释义',
		sortBy: '排序方式',
		AZ: '字母正序',
		ZA: '字母倒序',
		nearTime: '时间正序',
		Timeold: '时间倒序',
		sub: '保 存',
		English: '英',
		American: '美',
		savecg: '保存成功',
		word: '词',
		learn: '已学',
		Topics: '主题',
		cszt: '词书主题',
		alltopics: '全部主题',
		startLearning: '开始学习',
		New: '未学',
		All: '全部',
		nearlearned: '最近学的',
		next: '下一个',
		previous: '上一个',
		zmpx: '字母排序',
		gxhip: '恭喜，您今日已完成复习哦',
		addword: '已添加至我的单词本',
		delword: '已从我的单词本中取消',
		gxtip: '恭喜您完成当前主题',
		xxjd: '学习进度',
		hdztlb: '回到主题列表',
		nextTopi: '继续下一主题',
		sy: '释义',
		saveSuss: '保存成功',
		noyuyin: '当前没有语音',
		ddjs: '等当前语音播放结束',
		sfqx: '是否删除',
		qfx: '去复习',
		qxx: '去学习',
		ly: '来源',
		tznr: '拓展内容',
		xq: '详情',
		back: '返回',
		such: '搜索词汇',
		suls: '搜索历史',
		chls: '清除历史',
		claerchls: '是否清除历史记录?',
		suplear: '请输入中英文搜索词汇',
		jy1: '只支持英文的单引号、逗号、连字符',
		jzjr: '截至今日',
		wc: '已完成了',
		playW: '快来跟我一起学习吧'
	},
	communicate: {
		tip0: '请尽量使用文字描述问题，语音可能听不清，影响问题答疑准确性！',
		tip1: '老师将尽快与您沟通，请稍等',
		skfs: '松开发送',
		azsh: '按住说话',
		pleaseenter: '请输入',
		gift: '礼物',
		giftRecords: '礼物记录',
		noinput: '你还没有输入内容哦',
		uploading: '正在上传中',
		flower: '鲜花',
		salvo: '礼炮',
		suger: '糖果',
		paper: '爱的纸鹤',
		rockets: '真爱火箭',
		clouds: '冲上云霄',
		diamond: '钻戒',
		hug: '爱的抱抱',
		sending: '发送中',
		nojxj: '奖学金余额不足',
		isSending: '正在发送',
		lyd: '语音消息过短，无法发送',
		recording: '录音中',
		tomore9: '上传文件，不可超过九个！',
		tobig: '上传文件过大，请重新上传',
		toType: '上传文件的格式不正确，请重新上传！',
		uply: '上传录音中',
		allemo: '所有表情',
		zjsh: '最近使用',
		spjz: '上传视频加载中 请稍后',
		ltsx: '您的聊天功能已受限，建议您重新登录',
		IMbad: 'IM 未登录成功 请刷新 重新登录'
	},
	coupon: {
		name: '我的优惠券',
		type: '通用类',
		off: '折',
		qcspky: '全场商品可用',
		ljlq: '立即使用',
		m1: '满',
		sy: '使用',
		money: '元',
		zgj: '最高减',
		gq: '即将过期',
		zdky: '指定商品可用',
		zdbky: '指定商品不可用',
		yxq: '有效期'
	},
	order: {
		courseOrders: '课程订单',
		orderTime: '下单时间',
		successfulTransaction: '交易成功',
		learningGuidance: '学习指南',
		orderDetails: '课单详情页',
		orderTnformation: '订单信息',
		payment: '实付',
		orderNumber: '订单编号',
		paymentTime: '支付时间',
		clientInformation: '客户信息',
		name: '姓名',
		phoneNumber: '手机号',
		refund: '申请退款',
		refundDetails: '退款信息',
		refundTime: '退款申请时间',
		requestAmount: '退款申请金额',
		refundAmount: '退款金额',
		rejectTime: '退款/驳回时间',
		refundRreason: '退款原因',
		rejectReason: '驳回原因',
		submitSuccessfully: '提交成功',
		meetingTarget: '待成团',
		refunding: '待退款',
		refundDeclined: '退款驳回',
		refunded: '已退款',
		groupBuys: '成团查看'
	},
	evalTeaching: {
		jrbtjls: '加入我的不推荐老师名单',
		ComprehensiveEvaluation: '综合评价',
		zsph: '设置我的偏好',
		mloveTeacher1: '教师发音偏好',
	},
	jfdh: {
		title1: '获取条件',
		title2: '可得奖学金',
		hit1: '完成专题',
		hit2: '按照专题设定',
		hit3: '连续签到',
		hit4: '连续签到1、3、7天可分别获得1、3、7奖学金',
		hit5: '邀请新用户授权登录',
		hit6: '6',
		hit7: '用户首次授权登录',
		hit8: '3',
		hit9: '邀请好友PK获胜方',
		hit10: '0.1',
		hit11: '完成学习计划',
		hit12: '按照计划设定',
		hit13: '各类形式附赠',
		hit14: '按照附赠设定',
		hit15: '(包括企业附赠、购买套餐附赠等)',
		hit16: '积分仅在英语天天练中获得',
		hit17: '部分渠道获取的积分有使用期限，请在期限结束前使用，逾期将无法使用。即将过期的积分，在当前页面上有过期提醒，请注意查看。'
	},
	onsite: {
		apptip: '上岱恩语培app进行上课签到哦',
		apptip1: '下载岱恩语培app，新人免费学7天',
		Download: '下载',
		view: '查看',
		downloadTop: '如需下载，请至PC端进行下载',
		nyscgkj: '您已上传过课件',
		ClasTime: '上课时间：',
		SignInTime: '可签到时间：',
		RemoteCheckIn: '异地签到',
		viewImg: '查看拍照',
		SignInImg: '签到图片：',
		absenceFromDuty: '缺勤',
		PhotoCheckIn: '拍照签到',
		SignInImmediately: '立即签到',
		Signed: '已签到',
		Ended: '已结束',
		Successfully: '签到成功',
		signInNOtip: '未到签到时间，暂时无法签到',
		close: '关闭',
		handTip: '请手动开启定位权限，否则会无法成功签到',
		back: '返回',
		tip: '提 示',
		jsOpenPostionTop: '是否已打开定位权限',
		yes: '是',
		no: '否',
		signIn: '签到',
		RepeatedClockIn: '不可重复打卡',
		PositionQX: '监测到定位权限未开，请您开启定位权限',
		CameraQX: '监测到相机权限未开，请您开启相机权限',
		classroomArea: '您未在上课的有效区域内，是否确认签到？',
		courseFeedbackTitle1: '中期课程反馈',
		courseFeedbackTitle2: '结业课程反馈',
		courseFeedbackProblem1: '您对本课程现阶段学习内容的满意度。',
		courseFeedbackProblem01: '您对本课程学习内容的整体满意度。',
		courseFeedbackProblem2: '您对课程老师现阶段授课方式的满意度。',
		courseFeedbackProblem02: '您对本次课程老师授课方式的满意度。',
		courseFeedbackProblem3: '您对授课老师的满意度。',
		courseFeedbackProblem03: '您对授课老师的整体满意度。',
		courseFeedbackProblem4: '您对现阶段课程培训模式的满意度。',
		courseFeedbackProblem04: '您对本次课程培训模式的整体满意度。',
		courseFeedbackProblem5: '您对现阶段课程时长设置的满意度。',
		courseFeedbackProblem05: '您对本次课程时长设置的满意度。',
		courseFeedbackProblem6: '您对现阶段培训效果的满意度。',
		courseFeedbackProblem06: '您对本次培训效果的满意度。',
		courseFeedbackProblem7: '现阶段培训对您英语听、说能力的提高给予的帮助。',
		courseFeedbackProblem07: '本次培训对您英语听、说能力的提高给予的帮助。',
		courseFeedbackProblem8: '您想继续学习哪方面的内容？',
		courseFeedbackProblem9: '在此填写您的学习反馈、课程收获或学习心得吧！',
		ProblemSuccessTip: '提交成功，感谢您的评价',
		Enter: '请输入'
	},
	newFeedBack: {
		feedbackTip: '您反馈的问题是否已解决？',
		HistoricalFeedback: '历史反馈',
		feedbackQues1: '您已安装好岱恩语培App并清楚如何找到自己的课程？',
		feedbackQues01: '您已了解学习流程和学习目标并已开始正式学习？',
		feedbackQues2: '您已添加教务老师的企业微信，并已得到教务老师的指导？',
		feedbackQues02: '您已适应当前课程的学习模式和授课老师？',
		feedbackQues3: '您在学习过程中还有其他不清楚的地方或遇到什么困难吗？',
		feedbackQues4: '您已适应当前课程学习？',
		Comment: '备注',
		resolved: '已解决',
		isResolved: '确定您的反馈未解决？',
		yes: '是',
		no: '没有',
		nos: '否',
		has: '有',
		NotSuitable: '还不完全了解',
		Adaptation: '还不太适应',
		SubmittedTip: '提交成功，获得20奖学金！',
		SubsequentFeedback: '问题反馈处理与否调查',
		Survey: '问卷调查',
		Survey1: '反馈处理调查',
		QuestionnaireSurvey: '课程问卷调查',
		feedbackDialogTitle1: '课程问卷调查',
		feedbackDialogTitle2: '问题反馈处理与否调查',
		feedbackDialogText1: '欢迎您参加岱恩商务培训！为了不断改进我们的服务，提供更好的学习体验，请您抽出20秒的时间填写相关课程问卷。非常感谢您的支持！',
		feedbackDialogText2: '您的反馈已收到，已通知相关人员与您进行联系，请您花10秒时间填写一下问卷确认您的反馈是否得到解决。',
		later1: '稍后填写',
		later2: '稍后确认',
		Now1: '去填写',
		Now2: '去确认',
		Enter: '请输入备注',
		checkTip: '请填写问卷',
		questionnaireExpired: '问卷已过期'
	},
	newCenter: {
		cx: '畅学',
		xz: '下载',
		Follow: '关注',
		Setting: '设置',
		Exit: '退出',
		logoutConfirm: "确认退出登录？",
		tips: '提示',
		confirm: '确定',
		xzts: '下载岱恩语培APP注册账号',
		gzts: '关注岱恩语培公众号',
		ActivateStudyPass:"开通畅学卡",
		RenewStudyPass:"续费畅学卡",
		Remaining: "剩余：",
		Days: '天',
		jxj: '奖学金',
		ttlxf: '天天练学分',
		yhj: '优惠劵/张',
		zw: '暂无',
		gdcj: '更多成就',
		gmcxk: '购买畅学卡',
		zktq: '执卡特权:畅学课程全站免费学',
		myLesson: '历史课程',
		xlyjs: '训练营&竞赛',
		ks: '考试',
		sc: '收藏',
		yxls: '优选老师',
		gj: '跟进',
		kcdd: '课程订单',
		lljl: '浏览记录',
		dcb: '单词本',
		dlzc: '登录/注册',
	},
	newStudy: {
		SelectTime: '选择时间',
        expand: '查看更多',
        collapse: '收起',
        KhExercise: '课后练习',
        canVideo: "看视频",
      zbdk: "暂不订课",
      ljqd: "立即去订",
      dingsj: '订时间',
        TeacherQA: "老师答疑",
        finalExam: '结业测试',
        lszwkdzt: "老师暂无可带主题",
        LabelNew:'标签',
        dqztygq: "当前主题已过期",
        AvailableClasses: "可订课次数",
        Classover: "课程已结束",
        fxzhyyqgk: "分享至微信好友一起观看~",
        zawndkdkym: "正在为你打开订课页面",
        nhmyxydlso: "您还没有心仪的老师哦",
        mqyxlswkdk: "目前该优选老师没有可预约的上课时间，您可以选择其他优选老师的上课时间哦！",
        qtx: "请填写",
        xsrwwjk: "悬赏任务问卷库",

        HelloStudent: "你好，学员！",
        guidelinesTip: "请先根据指引完成入学测试",
        StartStudy : "开启课程学习！",
        CompleteLater: "暂不完成",
        CompleteEntranceTest: "完成入学测试",
        CourseCenter: "上课中心",
        YourCurrentLevel: "您当前等级",
        TaketheTest: "去测试",
        EntertheClassroom: "上课",
        Progress: "进度",
        PendingTasks: "待完成任务",
        ForeignTeacherSalonClass: "真人外教沙龙课",
        StartingSoon: "即将开始",
        LimitedQuotas: "少量名额",
        MoreRecommendedCourses: "更多推荐课程",
        LearningPerformance: "学习表现",
        Settings: "学习设置",
        StylePreferences: "上课风格偏好",
        PreferencesT1: "你希望老师的语速？",
        Normalspeed: "正常语速",
        Slowerspeed: "稍慢语速",
        PreferencesT2: "你希望老师纠错的严格度？",
        TimelyCorrections: "严格及时纠错",
        DelayCorrections: "少量延迟纠错",
        PreferencesT3: "课程开始时你希望老师破冰聊天吗？",
        Yes: "适当聊天，互相了解",
        No: "不要聊天，直接授课",
        Cancel: "取消",
        Confirm: "确定",
        PreferredTeachers: "优选老师",
        PreferredTeachers11: "优选老师",
        PreferredTeachersIip: "请在课后评价中设定优选老师",
        PreferredTimeSlots: "优选时段",
        Choose: "设置",
        PreferredTimeEdit: "修改优选时间段",
        Morning: "上午",
        Afternoon: "下午",
        Evening: "晚上",
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Sunday: "周日",
        PreferredTimeTip: "为了更方便的在订课时筛选课程主题，请设置优选时段",
        EarnedCredits: "已得学分",
        CurrentLevel: "当前级别",
        CompletedClass: "已完成授课",
        StartClass: "开启课程学习",
        BookClass: "去订课",
        lbBookClass: '订 课',
        liveBroadcast: '直播',
        min: '分钟',
        hksc: '上课时长',
        HelpCenter: "学习问题小智帮你",
        mybookclass: "我要订课",
        Askleave: "我要请假",
        MakeupLessons: "我要补课",
        OtherHelp: "其他帮助",
        DetailedCreditSummary: "已获学分明细",
        kqdx: "课前导学",
        Vocabulary: "课程词汇",
        gdj: "跟读句",
        points: "分",
        Learned: "已学习",
        View: "查看",
        EnterClassroom: "进入课堂",
        Currentlycompletedcourses: "当前已完成授课",
        Availablecoursebookings: "当前可订课次数",
        Numberofabsences: "当前已缺席次数",
        IGotit: "知道了",
        CancelTopic: "取消主题",
        EarnedCredits1: "已获得学分",
        Video: "实景短剧",
        videoTip: "刷短剧学英语就这么简单",
        Vocabularys: "词汇学习",
        VocabularysTip: "总有一天日积月累的单词会随口道来",
        KnowledgePoint: "知识点",
        KnowledgePointTip: "清晰明了的知识点对于学习至关重要哦",
        gdlx: '跟读练习',
        tzts: '拓展提升',
        FolloUp: "重点句跟读",
        FolloUpTip: "你离原声就差一步了，继续努力！",
        LiveClassroom: "真人课堂",
        ClassTime: "上课时间",
        CheckMaterials: "查看资料",
        ChangeTime: "更换时间",
        RemainingTimes: "剩余次数",
        AfterEvaluation: "课后评价",
        CheckEvaluation: "查看评价",
        EvaluateTeacher: "评价老师",
        cancelTopicTip: "确定取消该主题？",
        KnowledgePointLearning: "知识点学习",
        recordingTip: "点击波纹结束录音",
        Complete: "完成",
        LearnedVocabulary: "学习词汇",
        words: "个",
        EarnedCredits: "获得学分",
        credits: "学分",
        Relearn: "重新学习",
        KeyPointLearning: "知识点学习",
        wordContinue: "词汇学习",
        FolloUpContinue: "重点句跟读",
        examsContinue: "课前练习",
        Catalogue: '返回目录',
        studyKnowledge: '学习知识点',
        seconds: "秒",
        secondsmin: '秒',
        VocabularyPractice: "词汇练习",
        AnswerAnalysis: "答案解析",
        Wronganswer: "回答错误！请重新选择正确答案！",
        Example: "例句",
        studyTip01: "学习前，建议完成本课的预习，包含情景预览，词汇学习及知识点学习，可以帮助你更好的了解本科的学习内容，完成预习还可以获得学分，提升学习级别。",
        studyTip02: '如遇特殊情况无法按时上课，点击更换时间可调整上课时间（不会更换上课的主题和上课老师）',
        studyTip03: '如想更换本节课的学习内容，点击取消主题可取消当前主题（已完成的预习记录会保留）',
        studyTip04: "一次学完效果会更好哦,再坚持一会吧！",
        NoRemind: "不再提醒",
        StudyLater: "下次再学",
        ContinueStudying: "坚持学习",
        Teaching: "授课",
        studyTip05: "授课已完成，你对本次授课还满意吗？请对本次授课进行评价，留下宝贵的建议。",
        studyTip06: "如果你对本次上课的老师很满意，还可将其设为优选老师，后面订课时可以使用优选老师订课。",
        BackCourse: "返回课时",
        CompleteEvaluation: "完成评价",
        Replay: "重新播放",
        CompleteLearning: "完成学习",
        studyTip07: "一次学完效果更好哦！再坚持学一会吧！",
        StudyLater: "下次再学",
        ContinueStudying: "继续学习",
        studyTip08: "本节课老师缺席，请联系专属教务处理",
        studyTip09: "订课前请设置优选时段，设置后系统会优先为你推荐符合你优选时段的课程主题",
        ChoosePreferredTime: "设置优选时间段",
        ChoosePreferredTimeClick: "点击设置优选时间段",
        ChoosePreferredTimeTip: "优选时间段可设置多个",
        Back: "返回",
        ConfirmXZ: "确认选择",
        SelectTopic: "选择你想学习的主题",
        PreferredTimeSlots: "优选时段",
        PreferredTimeSlotsTip: "优选时段内无可选主题，请清空筛选条件并选择其他主题",
        PreferredTeacher: "优选老师",
        PreferredTeacherTip: "无优选老师可带主题，请清空筛选条件并选择其他主题",
        PreferredTimeSlotsTip02: "选择你更感兴趣的标签，选择后会优先展示此类标签对应的主题",
        Today: "今天",
        Tomorrow: "明天",
        DonSelect: "暂不选择",
        ConfirmSelection: "确认选择",
        OverallRating: "综合评分",
        AudioSupport: "支持音频上课",
        Seriousminded: "认真上课",
        PatientFriendly: "耐心亲切",
        XiaozhiTip01: "小智正在筛选你的课程主题",
        XiaozhiTip02: "上课期间与老师多多沟通，可获得最佳学习效果",
        NeoCredits: "Neo学分",
        ClassSessions: "上课次数",
        LearningLevel: "学习级别",
        NeoAccount: "账号",
        Password: "密码",
        Copy: "复制",
        OpenNeoApp: "打开Neo App",
        Rebook: "重订该课",
        QuickBooking: "快捷订课",
        neoStudyTip01: "请在正式学习Neo课程前下载Neo Study App，做好准备工作。",
        neoStudyTip02: "请先下载Neo App后进行学习！",
        NotLearning: "暂不学习",
        DownloadNow: "立即下载",
        CreditsDetails: "学分明细",
        TargetCredits: "目标学分",
        TargetCreditsTip: "目标学分为公司对个人要求的项目达标标准",
        CurrentLearningLevel: "当前学习级别",
        CompletedLevel: "已完成级别",
        BookAnyway: "仍要预定",
        PreviewFirst: "先去预习",
        TargetLevel: "目标级别",
        cueLevel: "当前级别",
        LearningProgress: "学习进度",
        UpgradeTest: "升级测试",
        SchedulingTip: "排课中，请耐心等待",
        SchedulingTip02: "列出你想要的上课时间",
        SchedulingTip03: "我们排课将更符合你的预期",
        SelectTime: "选择时间",
        SelectTimeTp01: "最多可选三个偏好时间",
        SelectTimeTp04: "注：选择偏好时间后，排课时会参考你所选的时间。",
        SelectTimeTp02: "任课老师已向你推送上课时间",
        ViewIntroduction: "查看介绍",
        ContactTeacher: "联系老师",
        DedicatedCoordinator: "专属教务",
        ContactCoordinator: "联系教务",
        AllSessions: "全部课次",
        Unattended: "未上课",
        Evaluated: "待评价",
        Completed: "已完成",
        Absent: "已缺席",
        AbsentTip01: "当前尚未上课，无需请假",
        AbsentTip02: "请选择想要请假的课",
        AbsentTip03: "请选择想要补的课",
        SelectTimeTp03: "偏好时间已选，排课时会参考你的偏好时间",
        WatchTheVideo:'完成实景短剧',


        qgjzd: "请根据指引开启课程学习！",
        YourTestLevel: "您的测试级别",
        LastTestLevel: "最近级别",
        days: "天",
        hours: "时",
        minutes: "分",
        ClassBegin: "开始上课啦！",
        TestBegin: "考试开始啦！",
        kyyyks: "可以预约考试时间啦！",
        rklsyts: "任课老师已推送时间！",
        xzsksj: "选择上课时间",
        Scheduling: "排课中",
        Registered: "已订阅",
        xtjcdnyycqkjl: "系统检测到你有一次缺课记录",
        RedeemLater: "暂不兑换",
        RedeemNow: "立即兑换",
        dqkyjxjbz: "当前可用奖学金不足，是否支付剩余金额？",
        bkcgh: '补课成功，您的选课次数增加1次！',
        NoMoreReminders: "不再提醒",
        jfqrzfcg: "是否确认支付成功",
        ksysx: "考试已失效",
        qwcrxcs: "请完成入学测试",
        wcrxcsh: "完成入学测试后，系统会根据你的测试成绩安排更适合你的课程主题",
        CompleteLater: "暂不完成",
        ToComplete: "去完成",
        bkcgbg: "不可超过8个",
        CertificationTest: "证书测试",
        GoToPreview: "去预习",
        SuggestedCredits: "建议学分",
        NeoCredits: "Neo学分",
        VocabularyList: "词汇表",
        kqlx: "课前练习",
        dzdlxkyqhxxdmr: "多做点练习可以强化学习的内容",
        Uploadfiles: "课件上传",
        scxyxxdnr: "上传想要学习的内容，老师课堂讲解",
        Uploadfiles1: "上传课件",
        ReUpload: "重新上传",
        Viewfiles: "查看课件",
        Teacher: "教师",
        ClassReview: "课堂回顾",
        khzy: "课后作业",
        khlx: '课后练习',
        wclxggxxjg: "完成练习，巩固学习效果",
        EvaluateTeacher: "评价老师",
        TeacherFeedback: "老师反馈",
        skqqwckxyxmr: "上课前请完成各预习内容，完成预习可获得学分，提升级别",
        djqxjkxzqxyt: "点击取消即可选择取消主题或更换上课时间",
        Cancelss: "取消整个主题",
        KeepRecord: "（保留预习记录）",
        jghsksj: "仅更换上课时间",
        SuccessfullyUpload: "上传成功！",
        bnghsj: "不能更换时间",
        qrqxdqks: "确认取消当前课时?",
        cancelledSuccessfully:'取消成功',
        zxrw: "自学任务",
        CreditsEarned: "已获学分",
        PastLevel: "历史级别",
        yhdxfmx: "已获得学分明细",
        jyneoxf: "建议Neo学分",
        Absent2: "本节课缺席",
        Absent3: "缺席",
        dqksjbymbjbbf: "当前课时级别与目标级别不符，不参与学习进度累计",
        PreviewProcess: "预习进度",
        ClassesAttended: "已上课次数",
        yjyggrnwc: "预计一个工作日内完成",
        Teacher1: "老师",
        Evaluate1: "去评价",
        bjClick: "补课",
        zwxfsj: "暂无学分数据",
        qxzxydcz: "请选择想要的操作",
        xzphsjh: "选择偏好时间后",
        pkshcknsxdsj: "排课时会参考你所选的时间。",
        szphsj: "设置偏好时间",
        SelectTime1: "选择时间",
        TimeRepeated: "时间重复",
        cbkcyl: "重播课程预览",
        Teacher2 : "讲师：",
        Play: "播放",
        SupportVideoClasses: "支持视频上课",
        SupportAudioClasses: "支持音频上课",
        ChineseTeachers: "中教",
        ForeignTeachers: "外教",
        ydyrs: "已订阅人数：",
        qxzsj: "请选择时间",
        Confirm2: "确定修改",
        jzxzsj: "禁止选择24H之内的时间",
        qjcg: "请假成功",
        cklsxq: "查看老师详情",
        swyx: "设为优选",
        qxxz: "取消优选",
        zbxz: "暂不选择",
        wdyxls: "我的优选老师",
        dkcg: "订课成功",
        sjggcg: "时间更改成功",
        qxzls: "请选择老师",
        Return2: "返回课程安排",
        dkywckyksbkdyx: "订课已完成，可以开始本课的预习哦",
        dkywcqzzsskqqb: "订课已完成，请在正式上课前确保Neo Study 建议学分已达成哦",
        zdnxxxdzt: "选择您想学习的主题",
        CurrentTopicLevel: "当前课程主题对应级别：",
        xzdbjhbzd: "选中的标签会被置顶，至多选择5个标签",
        yxsjnwkxzt: "优选时段内无可选主题",
        wyxlskdyj: "无优选老师可带主题",
        zdkxzwg: "最多可选择五个",
        gjhxddygjawx: "该计划下的第一个教案未学，请先选择第一个教案",
        SingleChoice: "单选题",
        NotCompleted: "尚未完成全部练习",
        Exit1: "是否退出？",
        StillExit: "坚持退出",
        Continue11: "继续完成",
        TopicName: "主题名称",
        srscxdzm: '输入要查询的字幕',
        Speed: '倍速',
        StusyLater: '下次再学',
        Continue22: '继续学习',
        sjywc: '视频学习已完成',
        Replay:'重新播放',
        Completed11: '完成学习',
        spjzcw: "视频加载错误",
        scbfwcqwftz: "首次播放完成前无法拖拽进度条",
        scbfwcqwfsy: "首次播放完成前无法使用该功能",
        zxtcjblndlxjl: "现在退出将保留你的练习记录",  
        dqjzmyyp: "当前句子没有音频",
        myzdly: "没有找到录音",
        qxgbdqbfyp: "请先关闭当前播放音频",
        ycxwxggh: "一次学完效果更好哦！再坚持一会吧！",
        ycwddcbkyc: "已从我的单词本中移除",
        DailySentence: "每日一句",
        dqysk: "当前已上课",
        dqneoxf: "当前Neo学分可订课次数",
        xxdfmmkzj : "Neo学习得分每满3000分可增加一次订课次数。",
        dkcghdkcs: "订课成功后订课次数-1",
        djzlkjrksym: "点击这里，可进入课时页面，查看当前课时包含的学习内容",
        djqylzjjr: "点击去预习，直接进入未完成的预习步骤中",
        lcnxyskdsj: "列出你想要上课的时间",
        wmpkjgfhndyq: "我们排课将更符合你的预期",
        Skip: "跳过",
        ChooseTime: "选择时间",
        CannotCancel: "不能取消",
        ndqwxbk: "你当前无需补课",
        jfljdhbkq: "是否立即兑换补课券？",
        wlyghdskty: "为了有更好的上课体验，请设置上课风格偏好哦",
        dqmyydydk: "当前没有已预订的课，无需请假",
        zxcs: "自学次数",
        zycs: "作业次数",
        xxzdsxhsndzt: "小智正在筛选合适你的课程主题",
        TestLevel:'测试等级',
        EvaluationTip: '评价是最真实的反馈～',
        Scholarship:"当前奖学金",
        CancelTip:"是否取消选择？",
        AllReviews:"全部评价",
        Bookings:"订课",
        Bookings1:"订课完成",
        ReadMore:"全文查看",
        Times:"倍数",
        salonJxjbz: '当前奖学金不足，是否使用现金支付？',
        LearnedBefore:'学过同系列课',
        booked:'已约过',
        Checktimetable: '查看课表',
        Zh: '中文',
        En: '英文',
        off: '字幕关',
        kczqpj: '课程中期评价',
        lsVideo:'视频',
        Preferred: '优选',
        Americanaccent: '美式口音',
        Britishaccent: '英式口音',
        Neutralaccent: '中性口音',
        American: '美式',
        British: '英式',
        Neutral: '中性',
    },
  newExam: {
    zbcc: "暂不重测",
    cxcs: "重新测试",
    rgjfhbj: "若感觉发挥不佳，可在考试时间内选择重新测试",
    zkcxcsyc: "注：只可重新测试一次",
    dj: "等级",
    pfz: "评分中",
    pfyc: "评分异常",
    cc: "重 测",
    fkxq: "反馈详情",
    neopluscsdj: "Neoplus 测试等级考试",
    aispeakingcs: "AI通用口测",
    aispeakingcs: "AI通用口测",
    zxbs: "在线笔试",
    aikycs: "AI口语测试",
    bfypfscw: '"播放音频"发生错误！',
    cgqxyy: "成功取消预约",
    AIkc: "AI 快测",
    certificate: "证书",
    wtfk:'问题反馈',
    TestBegin: "考试开始啦！",
    xzcxcs:'若感觉发挥不佳，可在考试时间内进行重测',
    aiIndustry:'AI行业口测'
  },
	read: {
        xxNext:'继续学习',
        UpdatingTips:'更新中，敬请期待...',
        readEnds:'完结撒花~',
        Subscribe: '立即订阅',
        KeyNotes:'重点复习',
        Exercise:'课后练习',
        Introduction:'课前导读',
        ExtendedReading:'拓展阅读',
        ListenandRead: '原文听读',
        CloseReading: '精读讲解',
        readTip01: '您尚未完成全部原文听读，',
        readTip0101: '进入精读讲解？',
        Again: "不再提示",
        Proceed: '进入精读讲解',
        Stay: '继续听原文',
        readTip02: '您尚未完成全部精读讲解',
        readTip0202: '是否完成阅读？',
        Finish: '完成阅读',
        Keeplearning: '继续听精读',
        readTip03: '完成本篇文章阅读',
        words: '词',
        Vocabulary: '核心词汇',
        Notes: '我的标记',
        Exercise: '去完成练习',
        nextArticle: '学习下一篇',
        readTip04: '你也可以去畅学加油站完成任务免费学习哦！',
        Translation: '小智快译',
        TranslationTip:'从当前句开始播放',
        deleteNote:'删除笔记',
        editNote: '编辑笔记',
        WriteNote:'写笔记',
        Markthissentence:'标记该句',
        noteTip: '人已经标记该句',
        noteTip1:'写下笔记有助于提升学习效果~',
        Note:'笔记',
        noteTip3: '长按文章中你喜欢的句子可以做笔记哦',
        noteTip4:'您还没有标记过句子，在文章中长按单词可以标记句子哦',
        yuanju:'原句',
        readZDJ: '阅读重点句',
        readTip05:'阅读开始前，小智想了解一下您的学习目标哦',
        readTip06:'请选择您要提升的英语能力，支持多选',
        qrxzBtn:'确认选择',
        noData:'暂无数据',
        remainTip: '您在当前页面已停留10分钟且未进行操作请确认您仍在设备前',
        Reading: '阅读文章',
        EnglishQuickReads: '英语快读',
        shareTip01: '精选地道英文素材，',
        shareTip02: '更适合职场人士的英语读物',
        shareTip3: '岱恩珍惜你的每一分付出',
        Sharefriends: '分享好友',
        Generateposter: '生成海报',
        Swipenextarticle: '滑动到下一篇',
        Preview: '试读',
        LimitedTimeDiscount: '限时折扣',
        CheckItOut:"去看看",
        Comments:"条评论",
        Handout:"课程讲义",
        ShareLearnFree:"分享好友免费试听",
        previewingTIP:"你尚未完将全部核心词汇预习完成",
        goReadTip:"是否进入原文听读？",
        EnterListenRead:"进入原文听读",
        PreviewKeyVocabulary:"预习核心词汇",
        noPlanTip:"该文章没有关联任何阅读计划",
        noSubscribed:"您尚未订阅当前阅读计划，请先订阅后查看",
        Notesempty:"笔记不能为空",
        NoAvailable:"暂无数据哦!",
        Scholarship:"奖学金",
        understandingTip: "通过几道习题，检测你对文章内容的理解",
        ReadAloud: "跟读训练",
        sentencesTip: "对重点句子进行跟读训练，加深记忆",
        VocabularyBuilding: "词汇积累",
        ReinforceTips: "通过巩固练习，帮助你进一步掌握本课的核心词汇",
        CompleteAFullTip: "完成一篇文章的完整学习即可获得一次学习奖励，每篇文章只能获得一次学习奖励",
        havenNoWords: "你还未添加过单词哦～",
        easyReviewTip: "可在课程学习、查词时将不认识的单词添加进单词本，方便回顾哦～",
        addPlanTip: "你还没有学习计划呢，制定学习计划后即可加入哦！",
        CreateNow: "立即制定",
        StartStudy: "开始学习",
        ReviewBtn: "开始复习",
        ReadShare: "课程分享",
        readShareTip: "岱恩精品课，邀你一起学！",
        ScholarshipsDoNot: "奖学金不用会过期哦！",
        RewardTasks: "奖励任务",
        LearningRewards: "学习奖励",
        ActivateStudyPass:"开通畅学卡",
        RenewStudyPass:"续费畅学卡",
        Remaining: "剩余天数：",
        Days: '天',
        nextTips01:"松开进入下一篇",
        goVocabulary:"进入词卡",
        Example:"例句",
        Discuss:"师生互动",
        CurrentPosition:"从当前位置开始播放",
        ZDVocabulary:"重点词汇",
        wordView:"查看词卡",
        CompleteEarnScholarships:"做任务得奖学金",
        TableOfContent:"课时列表",
        CouseDetails:"详情介绍",
        replayedPlayTip:"当前课时您已重复播放三次\n请确认您仍在设备前",
        SetNowTip:"请先设置偏好，获取学习计划课程列表后方可加入哦！",
        SetNow:"立即设置",
        theme: '专题',

    },

	..._zhLocale
}



// WEBPACK FOOTER //
// ./src/lang/zh.js